<template>
  <div class="submission-select-form">
    <eg-card
      :label="$t('imports.importSettings')"
      data-testid="lms-import-settings-form-class-assignment"
      onboarding-key="onboarding:clicked:lmsSubmissionFormClassAssignmentQuestionIcon"
    >
      <import-select-class
        :id="String(workspaceId)"
        class="mt-4"
        :value="selectedClassIds"
        :platform-key="platformKey"
        :bulk="false"
        @input="$emit('update:selectedClassIds', $event)"
        @loaded="onLoaded"
      />

      <import-select-assignment
        :id="String(workspaceId)"
        :value="selectedAssignments"
        :platform-key="platformKey"
        :class-ids="selectedClassIds"
        :bulk="false"
        :disabled="selectedClassIds.length === 0"
        @input="$emit('update:selectedAssignments', $event)"
        @loaded="onLoaded"
      />
    </eg-card>

    <eg-card
      data-testid="lms-import-submissions-form-select-submissions"
      :label="$t('imports.selectSubmissions')"
      onboarding-key="onboarding:clicked:lmsSubmissionFormSelectSubmissionsQuestionIcon"
    >
      <import-select-submissions
        :id="String(workspaceId)"
        class="mt-4"
        :value="selectedSubmissionsIds"
        :platform-key="platformKey"
        :class-id="selectedClassIds[0]"
        :assignment-id="selectedAssignments[0]?.id"
        :assignment-link="selectedAssignments[0]?.alternateLink"
        :bulk="false"
        :disabled="selectedAssignments.length === 0"
        @input="$emit('update:selectedSubmissionsIds', $event)"
        @loaded="onLoaded"
      />
    </eg-card>
  </div>
</template>

<script>
import ImportSelectSubmissions from "@/components/imports/imports_select_submissions.vue";
import ImportSelectAssignment from "@/components/imports/imports_select_assignment.vue";
import ImportSelectClass from "@/components/imports/imports_select_class.vue";

export default {
  name: "SubmissionSelectForm",
  components: {
    ImportSelectSubmissions,
    ImportSelectAssignment,
    ImportSelectClass,
  },
  props: {
    workspaceId: {
      type: [String, Number],
      required: true,
    },
    platformKey: {
      type: String,
      required: true,
    },
    selectedClassIds: {
      type: Array,
      default: () => [],
    },
    selectedAssignments: {
      type: Array,
      default: () => [],
    },
    selectedSubmissionsIds: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onLoaded() {
      this.$emit("loaded");
    },
  },
};
</script>

<style lang="scss" scoped>
.submission-select-form {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
</style>
